<script setup lang="ts">
    import { inject, onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: "",
        nom_fournisseur: "",
        representant: "",
        adresse: "",
        telephone: "",
        email: "",
        ville: "",
        pays: ""
    });
    const errors = reactive({
        nom_fournisseur: "",
        representant: "",
        adresse: "",
        telephone: "",
        email: "",
        ville: "",
        pays: ""
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        if (form_datas?.fournisseur) {
            const item = form_datas.fournisseur as any;
            formData.id = item.id;
            formData.nom_fournisseur = item.nom_fournisseur;
            formData.representant = item.representant;
            formData.adresse = item.adresse;
            formData.telephone = item.telephone;
            formData.email = item.email;
            formData.ville = item.ville;
            formData.pays = item.pays;
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;

        errors.nom_fournisseur = '';
        if (!formData.nom_fournisseur) {
            errors.nom_fournisseur ="Le nom du fournisseur est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                id: formData.id,
                nom_fournisseur: formData.nom_fournisseur,
                representant: formData.representant,
                adresse: formData.adresse,
                telephone: formData.telephone,
                email: formData.email,
                ville: formData.ville,
                pays: formData.pays
            };

            await axios.post(`/backoffice/market-fournisseurs/save`, formToUpload);
            router.push('/app/market/market-fournisseurs/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }
</script>

<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-30"></div>

        <section class="s20_mobile px-4">
            <div class="widget px-7 py-7">
                <h4 class="font-semibold mb-5">Fournisseurs Market / Edition <span class="text-sm text-grey-500"></span></h4>

                <div class="form-field-floating reactive active my-4">
                    <input type="text" class="form-input" v-model="formData.nom_fournisseur" name="nom_fournisseur" id="nom_fournisseur" placeholder="" autocomplete="off">
                    <label for="nom_fournisseur">Nom fournisseur <b class="color-danger">*</b></label>
                </div>
                <span v-if="!!errors['nom_fournisseur']" class="text-red">{{ errors['nom_fournisseur'] }}</span>

                <div class="form-field-floating reactive active my-4">
                    <input type="text" class="form-input" v-model="formData.representant" name="representant" id="representant" placeholder="" autocomplete="off">
                    <label for="representant">Nom &amp; prénoms représentant</label>
                </div>
                <span v-if="!!errors['representant']" class="text-red">{{ errors['representant'] }}</span>

                <div class="form-field-floating reactive active my-4">
                    <input type="text" class="form-input" v-model="formData.adresse" name="adresse" id="adresse" placeholder="" autocomplete="off">
                    <label for="adresse">Adresse</label>
                </div>
                <span v-if="!!errors['adresse']" class="text-red">{{ errors['adresse'] }}</span>

                <div class="form-field-floating reactive active my-4">
                    <input type="tel" class="form-input" v-model="formData.telephone" name="telephone" id="telephone" placeholder="" autocomplete="off">
                    <label for="telephone">Téléphone</label>
                </div>
                <span v-if="!!errors['telephone']" class="text-red">{{ errors['telephone'] }}</span>

                <div class="form-field-floating reactive active my-4">
                    <input type="email" class="form-input" v-model="formData.email" name="email" id="email" placeholder="" autocomplete="off">
                    <label for="email">Adresse email</label>
                </div>
                <span v-if="!!errors['email']" class="text-red">{{ errors['email'] }}</span>

                <div class="form-field-floating reactive active my-4">
                    <input type="tel" class="form-input" v-model="formData.pays" name="pays" id="pays" placeholder="" autocomplete="off">
                    <label for="pays">Pays</label>
                </div>
                <span v-if="!!errors['pays']" class="text-red">{{ errors['pays'] }}</span>

                <div class="form-field-floating reactive active my-4">
                    <input type="tel" class="form-input" v-model="formData.ville" name="ville" id="ville" placeholder="" autocomplete="off">
                    <label for="ville">Ville</label>
                </div>
                <span v-if="!!errors['ville']" class="text-red">{{ errors['ville'] }}</span>

                <div class="clear-both h-30"></div>
                <span v-if="!!errorMessage" class="text-red">{{ errorMessage }}</span>
                <p class="text-text-xs text-grey-500 mb-5"><b class="color-danger text-xs">*</b> Les champs marqués d'un astérisque sont obligatoires</p>
                <div class="flex gap-2">
                    <custom-button id="btn-submit" type="button" :classesList="'btn lg w-100'" :loading="loading" @click="onSubmit()">
                        <img src="/icons/icon-enregistrer.svg" class="btn-icon" alt="" />
                        <span>Enregistrer</span>
                    </custom-button>
                </div>
                
            </div>
        </section>
        
    </section>
</template>
